// src/hooks/app-config/useAppVersion.tsx

import {
  useState,
  useEffect,
  useContext,
  createContext,
  ReactNode,
} from 'react'

import { authHeader } from '../../api/'
import { refreshToken } from '../auth/'

const { REACT_APP_API_URL } = import.meta.env

const appVersionContext = createContext({})

type AppVersionProviderProps = {
  children: ReactNode
}

export const AppVersionProvider = ({ children }: AppVersionProviderProps) => (
  <appVersionContext.Provider value={useVersion()}>
    {children}
  </appVersionContext.Provider>
)

export const useAppVersion = () => useContext(appVersionContext)

const useVersion = () => {
  const [data, setData] = useState<number | null>(null)
  const [isError, setError] = useState(null)
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    ;(async () => {
      setLoading(true)
      setError(null)
      try {
        await refreshToken()

        const url = `${REACT_APP_API_URL}/system/appversion`
        const options = { method: 'GET', headers: { ...authHeader() } }
        const response = await fetch(url, options)
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const payload = await response.json()

        setData(
          payload?.data?.actual_version
            ? Date.parse(payload.data.actual_version)
            : null
        )
      } catch (error) {
        setError(error?.message || 'app version error')
      } finally {
        setLoading(false)
      }
    })()
  }, [])

  return { data, isError, isLoading }
}
